const listeners = new Set<() => void>();
export function assetReady(): void { for (const listener of listeners) listener(); }
export function subscribeAssets(listener: () => void): () => void { listeners.add(listener); return () => listeners.delete(listener); }
